<div id="forms" class="page-layout simple fullwidth" fxLayout="column">
    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
            <button mat-icon-button class="mr-16" (click)="regresarDetail()">
                    <mat-icon>arrow_back</mat-icon>
            </button>
              <h1 class="m-0">{{'PERFILES.EMPRESA.TITUHEAD' | translate}}</h1>
        </div>

       <div class="content-card p-20">
         <div class="" fxLayout="row" fxLayoutAlign="space-between stretch">
             <div fxFlex="50">
                 <mat-form-field appearance="outline" fxFlex>
                     <mat-label>{{'CONSULTATABLA.LOG_SISTEMA.BUSCADOR' | translate}}</mat-label>
                     <input matInput [(ngModel)]='busqueda' (keyup)="getListaEmpresas(1)" placeholder="{{'CONSULTATABLA.LOG_SISTEMA.PLACEHOLDER' | translate}}">
                 </mat-form-field>

             </div>
             <div fxFlex="50" fxLayout="row" fxLayoutAlign="end center">
                 <button mat-icon-button (click)="getListaEmpresas(prevPag)" [disabled]="!anterior">
               <mat-icon>keyboard_arrow_left</mat-icon>
             </button>
             <h3>{{'CONSULTATABLA.LOG_SISTEMA.PAGINA' | translate}} {{pagina}}</h3>
                 <button mat-icon-button (click)="getListaEmpresas(nextPag)" [disabled]="!siguiente">
               <mat-icon>keyboard_arrow_right</mat-icon>
             </button>

             <button mat-fab color="primary" (click)="getListaEmpresas(1)" matTooltip="{{'CONSULTATABLA.LOG_SISTEMA.ACTUALIZAR' | translate}}">
             <mat-icon>update</mat-icon>
             </button>
             </div>

         </div>

         <ng-container *ngIf="!cargando">
             <div fxLayout="column" fxLayoutAlign="space-between center">
                 <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                 <h1>{{'CONSULTATABLA.LOG_SISTEMA.CARGA' | translate}}</h1>
             </div>
         </ng-container>

         <table mat-table [dataSource]="resultadosUsuario" class="mat-elevation-z8" *ngIf="resultadosUsuario && cargando">

          <!-- Position Column -->
          <ng-container matColumnDef="usuario">
            <th mat-header-cell *matHeaderCellDef> {{'CONSULTATABLA.LOG_SENDGRIND.TABLA.USUARIO' | translate}} </th>
            <td mat-cell *matCellDef="let element" style="width: 20%;"> {{element.fullName}} </td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef> {{'CONSULTATABLA.LOG_SENDGRIND.TABLA.EMAIL' | translate}} </th>
            <td mat-cell *matCellDef="let element" style="width: 20%;"> {{element.email}} </td>
          </ng-container>

          <!-- Weight Column -->
          <ng-container matColumnDef="asunto">
            <th mat-header-cell *matHeaderCellDef> {{'CONSULTATABLA.LOG_SENDGRIND.TABLA.ASUNTO' | translate}} </th>
            <td mat-cell *matCellDef="let element">
              <mat-form-field appearance="outline" style="width: 95%;">
              <mat-label>{{'CONSULTATABLA.LOG_SENDGRIND.OPCION' | translate}}</mat-label>
              <mat-select (selectionChange)="onChange($event)">
                <mat-option *ngFor="let asunto of AsuntoGeneral" [value]="asunto">
                  {{asunto}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            </td>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="estatus">
            <th mat-header-cell *matHeaderCellDef> {{'CONSULTATABLA.LOG_SENDGRIND.TABLA.ESTATUS' | translate}} </th>
            <td mat-cell *matCellDef="let element" style="width: 15%;">
              <button mat-fab color="primary" matTooltip="{{'CONSULTATABLA.LOG_SENDGRIND.TOOLTIP' | translate}}" (click)="getEmail(element.email)">
              <mat-icon>search</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
    </div>
</div>
